import Text from '@sats-group/ui-lib/react/text';
import React from 'react';
import useClubLoadFactors from '~/client/hooks/use-club-load-factors';
import ClubLoadIndicator from '../club-load-indicator/club-load-indicator';
import DynamicImage from '../dynamic-image/dynamic-image';
import OpenStatus from '../open-status/open-status';
import type { LocationCard as Props } from './location-card.types';

const LocationCard: React.FunctionComponent<Props> = ({
  href,
  id,
  image,
  loadEndpoint,
  loadIndicator,
  openStatus,
  title,
  texts = [],
}) => {
  const [loadFactors] = useClubLoadFactors(loadEndpoint);

  return (
    <a className="location-card" href={href}>
      <div className="location-card__image">
        {image ? (
          <DynamicImage theme={DynamicImage.themes.rounded} {...image} />
        ) : null}
      </div>
      <div>
        <Text
          className="location-card__title"
          elementName="h3"
          size={Text.sizes.headline3}
          theme={Text.themes.emphasis}
        >
          {title}
        </Text>
        <Text className="location-card__text" size={Text.sizes.small}>
          {texts.map(text => (
            <p key={text}>{text}</p>
          ))}

          {openStatus ? <OpenStatus {...openStatus} /> : null}

          {loadIndicator && loadFactors[id] ? (
            <ClubLoadIndicator
              loadFactor={loadFactors[id]}
              theme={ClubLoadIndicator.themes.muted}
              {...loadIndicator}
            />
          ) : null}
        </Text>
      </div>
    </a>
  );
};

export default LocationCard;
